import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import DeleteTwoToneIcon from "@material-ui/icons/DeleteTwoTone";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
//number format plugin
import { NavLink } from "react-router-dom";
import numeral from "numeral";
import Grid from "@material-ui/core/Grid";


function descendingComparator(a, b, orderBy) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

function getComparator(order, orderBy) {
	return order === "desc"
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

const headCells = [
	// {
	// 	id: "itemName",
	// 	numeric: false,
	// 	disablePadding: true,
	// 	label: "Item Name",
	// },
	{ id: "date", numeric: false, disablePadding: false, label: "Date" },
	{ id: "reference", numeric: false, disablePadding: false, label: "Reference" },
	{ id: "amount", numeric: true, disablePadding: false, label: "Amount" },
	// {
	// 	id: "discount",
	// 	numeric: true,
	// 	disablePadding: false,
	// 	label: "Discount",
	// },
	// {
	// 	id: "total",
	// 	numeric: true,
	// 	disablePadding: false,
	// 	label: "Total",
	// 	numeric: true,
	// },
	{
		id: "action",
		numeric: true,
		disablePadding: false,
		label: "Action",
	},
];

function EnhancedTableHead(props) {
	const {
		classes,
		onSelectAllClick,
		order,
		orderBy,
		numSelected,
		rowCount,
		onRequestSort,
	} = props;
	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow>
				{/* <TableCell padding="checkbox">
					<Checkbox
						indeterminate={
							numSelected > 0 && numSelected < rowCount
						}
						checked={rowCount > 0 && numSelected === rowCount}
						onChange={onSelectAllClick}
						inputProps={{ "aria-label": "select all desserts" }}
					/>
				</TableCell> */}
				{headCells.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={headCell.numeric ? "right" : "left"}
						padding={headCell.disablePadding ? "none" : "default"}
						sortDirection={orderBy === headCell.id ? order : false}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : "asc"}
							onClick={createSortHandler(headCell.id)}
						>
							{headCell.label}
							{orderBy === headCell.id ? (
								<span className={classes.visuallyHidden}>
									{order === "desc"
										? "sorted descending"
										: "sorted ascending"}
								</span>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}

EnhancedTableHead.propTypes = {
	classes: PropTypes.object.isRequired,
	numSelected: PropTypes.number.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	onSelectAllClick: PropTypes.func.isRequired,
	order: PropTypes.oneOf(["asc", "desc"]).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
	root: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
	},
	highlight:
		theme.palette.type === "light"
			? {
					color: theme.palette.secondary.main,
					backgroundColor: lighten(
						theme.palette.secondary.light,
						0.85
					),
			  }
			: {
					color: theme.palette.text.primary,
					backgroundColor: theme.palette.secondary.dark,
			  },
	title: {
		flex: "1 1 100%",
	},
}));

const EnhancedTableToolbar = (props) => {
	const classes = useToolbarStyles();
	const { numSelected, warehouse } = props;

	return (
		<Toolbar
			className={clsx(classes.root, {
				[classes.highlight]: numSelected > 0,
			})}
		>
			{numSelected > 0 ? (
				<Typography
					className={classes.title}
					color="inherit"
					variant="subtitle1"
					component="div"
				>
					{numSelected} selected
				</Typography>
			) : (
				<Typography
					className={classes.title}
					variant="h6"
					id="tableTitle"
					component="div"
				>
					Nutrition 
				</Typography>
			)}

			{numSelected > 0 ? (
				<Tooltip title="Delete">
					<IconButton aria-label="delete">
						<DeleteIcon />
					</IconButton>
				</Tooltip>
			) : (
				<Tooltip title="Filter list">
					<IconButton aria-label="filter list">
						<FilterListIcon />
					</IconButton>
				</Tooltip>
			)}
		</Toolbar>
	);
};

EnhancedTableToolbar.propTypes = {
	numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
	},
	paper: {
		width: "100%",
		marginBottom: theme.spacing(2),
	},
	table: {
		minWidth: 750,
	},
	visuallyHidden: {
		border: 0,
		clip: "rect(0 0 0 0)",
		height: 1,
		margin: -1,
		overflow: "hidden",
		padding: 0,
		position: "absolute",
		top: 20,
		width: 1,
	},
	deleteIcon: {
		cursor: "pointer",
		color: "#dc004e !important",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
}));

export default function EnhancedTable(props) {
	const classes = useStyles();
	const [order, setOrder] = React.useState("asc");
	const [orderBy, setOrderBy] = React.useState("name");
	const [selected, setSelected] = React.useState([]);
	const [page, setPage] = React.useState(0);
	const [dense, setDense] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = React.useState(5);

	//get items from POInfo component
	const {items, branchidno, type} = props;
	let rows = items;

	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === "asc";
		setOrder(isAsc ? "desc" : "asc");
		setOrderBy(property);
	};

	const handleSelectAllClick = (event) => {
		if (event.target.checked) {
			const newSelecteds = rows.map((n) => n.name);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleClick = (event, name) => {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}

		setSelected(newSelected);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleChangeDense = (event) => {
		setDense(event.target.checked);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// console.log(e);
        //setTitle(''); close the popup after adding
    }

	const isSelected = (name) => selected.indexOf(name) !== -1;

	const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

	return (
		<div className={classes.root}>
			{/* <EnhancedTableToolbar numSelected={selected.length} /> */}
			<Grid item xs={8}>
								<div className={classes.miniTitle}>
									Allocations
								</div>
			</Grid>
			<TableContainer>
				<Table
					className={classes.table}
					aria-labelledby="tableTitle"
					size={dense ? "small" : "medium"}
					aria-label="enhanced table"
				>
					<EnhancedTableHead
						classes={classes}
						numSelected={selected.length}
						order={order}
						orderBy={orderBy}
						onSelectAllClick={handleSelectAllClick}
						onRequestSort={handleRequestSort}
						rowCount={rows.length}
					/>
					<TableBody>
						{stableSort(rows, getComparator(order, orderBy))
							.slice(
								page * rowsPerPage,
								page * rowsPerPage + rowsPerPage
							)
							.map((row, index) => {
								const isItemSelected = isSelected(row.name);
								const labelId = `enhanced-table-checkbox-${index}`;

								return (
									<TableRow
										hover
										onClick={(event) =>
											handleClick(event, row.name)
										}
										role="checkbox"
										aria-checked={isItemSelected}
										tabIndex={-1}
										key={row.item_id}
										selected={isItemSelected}
									>
										<TableCell
											component="td"
											id={labelId}
											scope="row"
											padding="none"
										>
											{row.date}
										</TableCell>
										<TableCell>

											{row.reference}
										</TableCell>
										<TableCell align="right">
											{numeral(row.amount).format('00,0.00')}
										</TableCell>
										<TableCell>
										{/* type == 1, render view logic for PurchaseAllocateView
											type == 0, else in ternary condition, render view logic for PurchaseOrderDetailsReference 
											reftype == PO Return >> navlink url = get_returned_po_details
											reftype == PO Return >> navlink url = check_view_reference*/}
										{(type===1) ? 
											(
												<Grid container direction="row" justify="flex-end">
													<NavLink to={"/purchases/purchases-order-details-reference/"+row.allocrefid+"/"+branchidno}>											
														<Button variant="contained" color="primary">
															View
														</Button>	 
													</NavLink> 
												</Grid>   
											) : (type===0) ? ( row.reftype === 'PO Return' ? 
															(
																<Grid container direction="row" justify="flex-end">
																	<NavLink to={"/purchases/purchases-order-allocate-view/"+row.allocrefid+"/"+branchidno}>										
																		<Button variant="contained" color="primary">
																			View PO Return
																		</Button>	 
																	</NavLink> 
														    	</Grid> 
															) : (row.reftype === 'PO Payment') ? 
															(
																<Grid container direction="row" justify="flex-end">
																	<NavLink to={"/account/check-view-reference/"+row.allocrefid+"/"+branchidno}> {/*Check View Reference */}										
																		<Button variant="contained" color="primary">
																			View PO Payment
																		</Button>	 
																	</NavLink> 
																</Grid> 	
															) : (<div></div>))
												    // if($rowrecord["reftype"]=="PO Return")
                									// {
                									//     $echo.='<td><a href="purchasereturnview.php?poretno='.$rowrecord["refid"].'"><span class="label label-success">View</span></a></td>';
                									            //use get_returned_po_details api here // purchaseAllocateView.jsx
                									// }
                									// else if($rowrecord["reftype"]=="PO Payment")
                									// {
                									//     $echo.='<td><a href="checkviewreference.php?chkno='.$rowrecord["refid"].'"><span class="label label-success">View</span></a></td>';
                									    //use check_view_reference api
                									// }
															
											  : (<div></div>)
										}
										</TableCell>
									</TableRow>
								);
							})}
						{/* {emptyRows > 0 && (
							<TableRow
								style={{
									height: (dense ? 33 : 53) * emptyRows,
								}}
							>
								<TableCell colSpan={6} />
							</TableRow>
						)} */}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[5, 10, 25]}
				component="div"
				count={rows.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onChangePage={handleChangePage}
				onChangeRowsPerPage={handleChangeRowsPerPage}
			/>
			{/* <FormControlLabel
				control={
					<Switch checked={dense} onChange={handleChangeDense} />
				}
				label="Dense padding"
			/> */}
		</div>
	);
}
